<smt-modal 
    [(isActive)]="enableMissingUosModal" 
    (acceptEvent)="saveMissingUosModal()"
    (rejectEvent)="closeMissingUosBlockModal()" 
    acceptText="Save" 
    acceptCssClass="button primary" 
    (disableAcceptConditions)="!enableMissingModalSave()"
    rejectText="Cancel"
    rejectCssClass="button cancel">

    <div role="header">
        {{ missingUosModalTitle }}
    </div>    
    <div role="body">
        <div class="form-group compact">            
            <label>Select Day</label>
            <select name="missingUos" id="missingUosDropDown" class="body-dropdown" [(ngModel)]="selectedMissingUosBlock">
                <option *ngFor="let missingUosBlock of missingUosBlocks" [ngValue]="missingUosBlock">
                    {{ formatMissingUosBlock(missingUosBlock) }}
                </option>
            </select>  
        </div>
        <div *ngIf="selectedMissingUosBlock" class="form-group compact">   
            <label>Enter values for {{ formatMissingUosBlock(selectedMissingUosBlock) }}</label>
            <form [formGroup]="enterUOSForm">      
                <div *ngFor="let missingBlock of selectedMissingUosBlock.missingBlocks" class="shift-block workflow-input">
                    <label>{{ formatMissingBlockHoursOnly(missingBlock) }}</label>
                    <input type="number" min="{{ minValue }} " max="{{ maxValue }}" [formControlName]="getShiftBlockControlName(missingBlock.shiftBlock.id)" id="{{ getShiftBlockControlName(missingBlock.shiftBlock.id) }}" [(ngModel)]="missingBlock.total">
                    <label *ngIf="costCenter.ancillaryConfiguration.enterUOSByBlock" class="total" for="{{ getShiftBlockControlName(missingBlock.shiftBlock.id) }}">Total</label>
                    <label *ngIf="!costCenter.ancillaryConfiguration.enterUOSByBlock" for="{{ getShiftBlockControlName(missingBlock.shiftBlock.id) }}">{{ getShiftBlockLabel(missingBlock.shiftBlock) }}</label>
                    <div *ngIf="valueOutOfRange(missingBlock.shiftBlock.id)" class="validation-message warning">
                        Value must be between {{ minValue }} and {{ maxValue | number }}.
                    </div>
                    <div *ngIf="valueOutOfPattern(missingBlock.shiftBlock.id)" class="validation-message warning">
                        Decimal values are invalid.
                    </div>
                </div>
            </form>
        </div>
        <div *ngIf="showSaveError"class="missingBlocks warning">
            An error occurred and these values were not saved.
        </div>
    </div>    
</smt-modal>
<div class="page-header-outer">
    <div class="page-header">
        <h1>Update the Staffing Plan</h1>
        <div class="sub-title" *ngIf="costCenter">
            <a [routerLink]="changeCostCenter">{{costCenter.name}} {{costCenter.number}}</a> 
            <ng-template [ngIf]="shiftBlock"> / <a [routerLink]="changeShiftBlock">{{formattedShiftBlockRange()}}</a></ng-template>
            <div class="missingBlocks warning" *ngIf="missingBlocksLoading">
                Shift history is being verified.
            </div>
            <div class="missingBlocks warning" *ngIf="missingBlocksCount" (click)="openMissingBlocks()">
                * There are {{ missingBlocksCount }} missing shift records in the last {{ numberOfDays }} days. Click here to view them.
            </div>
            <div class="missingBlocks warning orange" *ngIf="missingUosBlocksCount" (click)="openMissingUosBlocks()">
              * There are {{ missingUosBlocksCount }} missing records for {{ unitOfServiceCategory }} in the last {{ numberOfDays }} days. Click here to view them.
            </div>
        </div>
    </div>
  </div>